import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import { FormattedMessage } from 'react-intl';

export default class AFileUpload extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			fileName: get(props, 'file.name', ''),
		};
		this.handleOnChange = this.handleOnChange.bind(this);
	}
	componentDidMount() {
		this.initDrop();
		this.initDragOver();
	}

	componentWillReceiveProps(props) {
		if (props.file && props.file.name !== this.state.fileName) {
			this.setState({ fileName: props.file.name });
		}
	}

	initDragOver() {
		document.querySelector(`#${this.props.id}`).addEventListener('dragover', (ev) => {
			ev.preventDefault();
		});
	}

	initDrop() {
		document.querySelector(`#${this.props.id}`).addEventListener('drop', (ev) => {
			ev.preventDefault();
			document.querySelector((`#${this.props.id}`)).files = ev.dataTransfer.files;
		});
	}

	handleOnChange() {
		const file = document.getElementById(this.props.id).files[0];
		this.setState({ fileName: file.name });

		if (this.props.onChange) {
			this.props.onChange(file);
		}
	}

	render() {
		return (
			<label htmlFor={this.props.id} className={`a-file-upload ${this.props.className}`}>
				<input
					id={this.props.id}
					type="file"
					placeholder={this.props.placeholder}
					required={this.props.required}
					error={this.props.error}
					onChange={this.handleOnChange}
					accept="application/pdf"
				/>
				<p>{this.state.fileName}</p>
				<p className="a-button">
					<FormattedMessage id="FORM.SELECT_FILE" defaultMessage="" />
				</p>
			</label>
		);
	}
}

AFileUpload.propTypes = {
	id: PropTypes.string.isRequired,
	placeholder: PropTypes.string,
	className: PropTypes.string,
	file: PropTypes.object,
	required: PropTypes.bool,
	error: PropTypes.bool,
	onChange: PropTypes.func,
};

AFileUpload.defaultProps = {
	placeholder: '',
	className: '',
	file: undefined,
	required: false,
	error: false,
	onChange: undefined,
};



// WEBPACK FOOTER //
// ./src/components/atoms/_atoms.file-upload.js